import { MessageCircle } from 'lucide-react';
import { BRAND, scrollToId } from '../config/site';

export const StickyMobileCTA = () => (
  <div className="fixed inset-x-0 bottom-0 z-40 border-t border-navy/10 bg-white/95 px-4 py-3 backdrop-blur-md md:hidden">
    <div className="flex gap-3">
      <button
        type="button"
        data-testid="mobile-sticky-quote-button"
        onClick={() => scrollToId('quote')}
        className="flex-1 rounded-full bg-electric py-3 text-xs font-bold uppercase tracking-wide text-white shadow-soft"
      >
        Get a Free Quote
      </button>
      <a
        href={BRAND.smsHref}
        data-testid="mobile-sticky-text-button"
        className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border-2 border-navy/15 bg-white py-3 text-xs font-bold uppercase tracking-wide text-navy"
      >
        <MessageCircle size={14} />
        Text Us
      </a>
    </div>
  </div>
);

export default StickyMobileCTA;
